import { Link } from 'react-router';
import { Button, Card, Mascot, useToast } from '@redpandev/ui';

/**
 * Petite carte de partage vers le profil public (page compte).
 * Copie le lien complet dans le presse-papiers avec un toast de confirmation.
 */
export function ShareProfileCard({ displayName }: { displayName: string }) {
  const { push } = useToast();
  const path = `/u/${encodeURIComponent(displayName)}`;

  const copy = async () => {
    const url = `${window.location.origin}${path}`;
    try {
      if (!navigator.clipboard) throw new Error('clipboard_unavailable');
      await navigator.clipboard.writeText(url);
      push({ intent: 'success', title: 'Lien copié !', description: 'Partage ton repaire.' });
    } catch {
      push({ intent: 'error', title: 'Copie impossible', description: url });
    }
  };

  return (
    <Card className="flex flex-wrap items-center gap-4 border-grape-500/30">
      <Mascot mood="excited" size={48} animated={false} />
      <div className="min-w-0 flex-1">
        <p className="font-display font-semibold text-ink-100">Ton profil public</p>
        <Link to={path} className="break-all font-mono text-sm text-sky-400 hover:underline">
          /u/{displayName}
        </Link>
      </div>
      <Button variant="secondary" size="sm" onClick={copy} className="w-full sm:w-auto">
        Copier le lien
      </Button>
    </Card>
  );
}
